var exports = {
  "S": "AvatarDecorationLayer.module__image___VVk3aV",
};

module.exports = exports;
